const data = 
[
    {
        "brand": "Sony",
        "camera": "RX100 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅳ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.30",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "RX100 V",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "RX100 VA",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅵ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅶ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "ZV-1M2",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.20",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off.\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]\n3.Set\"Still Img. Save Dest.\" to be \"Camera Only\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n4.Please set [Auto Review] to be\"Off\" when shooting the timelapse video or Panorama;\n5.After connecting the cable, be sure to power on the SCORP-Mini  before the camera.\n6.The camera icon on the gimbal screen lights up after a successful connection. And the screen of the camera displays the characters \"PC\".\n7.When the camera is in photo mode, you can switch between photo and video modes from gimbal; when the camera is in video mode, the gimbal can only control recording video.\n8.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "DSC-HX90",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "DSC-WX500",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A5100",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.10",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": 1.01,
        "note": "1.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]Set the \"USB Connection\" to be \"Computer Remote\". The specific setting method is as follows: Step 1: Set the computer remote control on the camera.MENU -- network -- transmission/remote -- Computer remote control function -- computer remote control -- open\n2.Set \"\"Still Img. Save Dest.\"\" to be \"\"Camera Only\"\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n3.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX0",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX0 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.20",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "3.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable,be sure to power on the SCORP-Mini  before the camera.\n2.Support Optical Zoom; Please set [Zoom Setting] to be \"ClearImage Zoom\" or \"Digital Zoom\" to enable Digital Zoom.\n3.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini  before the camera.\n2.Please set the [Ctrl w/ Smartphone] to be off.\n(Network) → [Ctrl w/ Smartphone] → [Off]\n3.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]\n4.Set \"Still Img. Save Dest.\" to be \"Camera Only\":\n (Network) → [PC Remote Function] →[Still Img. Save Dest.]→[Camera Only]\n5.Please set [Auto Review] to be \"Off\" when shooting the timelapse video or Panorama;\n6.Support Switch Photo/ Video Mode in P, A, S, M, AUTO Mode."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "2.1",
        "gimbalFirmware": "1.03",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "×",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.1",
        "gimbalFirmware": "1.03",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on.\n3.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n4.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlLine": "Type-C to Multi",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "√",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "1.05",
        "note": "1.After connecting the cable, be sure to power on the gimbal before the camera.\n2.Operate digital zoom,the camera's digital zoom function needs to be turned on.\n3.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.01",
        "gimbalFirmware": "1.05",
        "note": "1.Please set the [Ctrl w/ Smartphone] to be off：\n(Network) → [Ctrl w/ Smartphone] → [Off]\n2.Set \"USB Connecting\" to be \"PC Remote\":\n (Network) → [PC Remote Function] →[PC Remote]→[On]Set the \"USB Connection\" to be \"Computer Remote\". The specific setting method is as follows: Step 1: Set the computer remote control on the camera.MENU -- network -- transmission/remote -- Computer remote control function -- computer remote control -- open\n3.When using the electronic focusing function of the camera, you need to set the lens mode to AF and camera mode to MF.\n4.Settings to avoid losing photos when taking photos: \n Network → Transfer/Remote → PC Remote Control → Still Img. Save Dest. → Camera only.\n5.Since the Bluetooth shutter has a higher priority,if adjust camera parameters such as aperture,shutter,ISO by connecting with shutter release cable.Please make sure bluetooth is disconnected .\n6.Please make sure the dail on the camera is set to M mode."
    },
    {
        "brand": "Canon",
        "camera": "EOS M50",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "1.02",
        "note": "1.SCORP-Mini can switch to video mode from P,A,M shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off"
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "1.01",
        "note": "1.SCORP-Mini can switch to video mode from P,A,M shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off"
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.8.0",
        "gimbalFirmware": "1.01",
        "note": "1.SCORP-Mini can switch to video mode from P,A shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode  camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off.\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.3.0",
        "gimbalFirmware": "1.01",
        "note": "1.SCORP-Mini can switch to video mode from P,A shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode  camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off.\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS M6",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "1.01",
        "note": "1.SCORP-Mini can switch to video mode from P,A shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.Please do not use the release cable to control the video recording while in photo mode  camera as it is easy to cause the camera crash.\n4.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off.\n5.It shows that using the adapter with the EF Mount Lens will increase the delay of pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.1",
        "gimbalFirmware": "1.01",
        "note": "1.SCORP-Mini  can switch to video mode from P,A,M shooting mode, but need to switch to video mode from photo mode on camera manually.\n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off"
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "controlLine": "Type-C to Micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "1.03",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.3.0",
        "gimbalFirmware": "1.01",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus.\n3.When shooting timelapse video, please set the Canon camera \"Image Review\" to be off."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.4.0",
        "gimbalFirmware": "1.04",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "V1.05",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.1",
        "gimbalFirmware": "V1.05",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS R8",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "V1.07",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.0.0",
        "gimbalFirmware": "V1.07",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Canon",
        "camera": "EOS R6 Mark Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "√",
        "aperture": "√",
        "sensor": "√",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.1.2",
        "gimbalFirmware": "V1.09",
        "note": "1.Please switch photo / video mode on camera manually. \n2.Switch to \"MF\" Mode on the lens when use pull focus."
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.70",
        "gimbalFirmware": "1.01",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.2",
        "gimbalFirmware": "1.01",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to DC2.5mm",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "1.01",
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": 1,
        "gimbalFirmware": "1.01",
        "note": "1.Set the USB Mode to be PC(tether) on camera.\n2.Turn off the Camera Wi-Fi before use the cable to control camera as Wi-Fi and USB Trigger can not used at the same time.\n3.The camera will auto focus when control capture photo.\n4.To pull focus with gimbal, the focus mode toggle on the camera should be set to MF."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.20",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "controlLine": "Type-C to TRS3.5\n(Optional)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "×",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.30",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "3.01",
        "gimbalFirmware": "1.01",
        "note": "1.Make sure to connect Feiyu SCORP to the camera ø2.5mm port.\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Make sure to connect Feiyu SCORP to the camera ø2.5mm port.\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.01",
        "gimbalFirmware": "1.01",
        "note": "1.Make sure to connect Feiyu SCORP to the camera ø2.5mm port.\n2.Please switch photo/ video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "controlLine": "Type-C to TRS3.5\n(Optional)",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "controlLine": "Type-C to TRS3.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "V1.19beta",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-E3",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.22",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X100V",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.02",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "controlLine": "Type-C to TRS2.5",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "√",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": 1.21,
        "gimbalFirmware": 1.07,
        "note": "Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "controlLine": "Type-C to micro",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.02",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually. \n3.To operate digital focusing in video mode, you need to set the camera's focusing mode to AF-FS or AF-FC.  When operating digital focus in photo mode, the focus mode of the camera cannot be MF mode."
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "2.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "3.31",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.00",
        "gimbalFirmware": "1.01",
        "note": "1.Please set [MIC/REMOTE RELEASE] to be [REMOTE] under the [MOVIE SETTING] menu\n2.Please switch photo / video mode on camera manually."
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "1.11",
        "gimbalFirmware": "1.05",
        "note": "1.After connecting the cable, be sure to power on the SCORP-Mini before the camera.\n2.After connecting the cable, be sure to power on the \n Feiyu SCORP before the camera and wait for about 6 seconds for successfully connection after camera power on\n3.Please switch photo / video mode on camera manually.\n4.If you go back to the album and play the video, you have to reconnect to control it again."
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "controlLine": "Type-C to Type-C",
        "photo": "√",
        "video": "√",
        "lineTimeMonitor": "√",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "√",
        "zoom": "×",
        "cameraFirmware": "1.10",
        "gimbalFirmware": "V1.04",
        "note": "1.After connecting the cable, be sure to power on the Feiyu gimbal before the camera and wait for about 6 seconds for successfully connection after camera power on\n2.Please switch photo / video mode on camera manually.\n3.To operate digital focusing in video mode, you need to set the camera's focusing mode to AF-FS or AF-FC.  When operating digital focus in photo mode, the focus mode of the camera cannot be MF mode."
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "controlLine": "Type-C to Type-C",
        "photo": "×",
        "video": "√",
        "lineTimeMonitor": "×",
        "shutter": "×",
        "aperture": "×",
        "sensor": "×",
        "halfShutter": "×",
        "focus": "×",
        "zoom": "×",
        "cameraFirmware": "4.00",
        "gimbalFirmware": "1.02",
        "note": "1.Select \"Camera Control\" for USB mode;\n2.All keys of the camera are unavailable after the connection with the SCORP-Mini"
    }
]

export default data